import { EntityList } from '../../components/entity-list';
import { SubjectForm } from '../../forms/simple-forms';
import { useT } from '../../i18n';

/**
 * The school's subjects.
 */
export const SubjectsScreen = () => {
  const t = useT();
  return (
    <EntityList
      entity="subjects"
      title={t('subjects.title')}
      caption={t('subjects.caption')}
      createLabel={t('subjects.new')}
      editTitle={t('subjects.edit')}
      emptyTitle={t('subjects.empty.title')}
      emptyBody={t('subjects.empty.body')}
      columns={[
        {
          key: 'name',
          header: t('subjects.column.name'),
          cell: (row) => <span className="font-medium text-gray-900">{row.name}</span>,
          sortable: true,
          sortValue: (row) => row.name,
        },
        {
          key: 'code',
          header: t('subjects.column.code'),
          cell: (row) => row.code ?? t('common.none'),
        },
      ]}
      renderForm={({ current, onDone }) => <SubjectForm current={current} onDone={onDone} />}
    />
  );
};
